import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Row, Col, Card, CardBody, Input, Button, Table, FormGroup, Label, UncontrolledDropdown, DropdownToggle, DropdownMenu, InputGroup, InputGroupAddon } from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import APIClient from '../../helpers/APIClient';
import Loader from '../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import moment from 'moment';
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import IconCalendar from '../../assets/images/icon/ic_calendar-black.svg';
import styled from 'styled-components';
import { PaymentMethod } from './PaymentList';
import NumberFormat from 'react-number-format';
import TextUtils from '../../helpers/TextUtils';
import AsyncSelect from "react-select/async";
import { Link } from 'react-router-dom';
import { getLinkBySourceCode } from '../../helpers/SourceCode';
import { ReceiptsGroup } from '../receipts/ReceiptsList';
import PriceUtils from '../../helpers/PriceUtils';

const Detail = (props: any) => {
    const [customers, setCustomers] = useState<any>([]);
    const [users, setUser] = useState<any>([]);
    const [branch, setbranch] = useState<any>([]);
    const [supplier, setSupplier] = useState<any>([]);
    const [payment_type, setReceipts_type] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any>({
        day: moment().valueOf(),
        branch_id : props?.user?.branch_id?.id,
    });
    const [actionType, setActionType] = useState<any>();
    const [view, setView] = useState<any>();
    const [dataCurrent, setDataCurrent] = useState<any>([]);
    const [dataCustomer, setDataCustomer] = useState<any>({});
    const [dataSupplier, setDataSupplier] = useState<any>({});
    const [isSource, setIsSource] = useState<any>(false);
    const [isCustomer, setIsCustomer] = useState<any>(false);
    const [isSupplier, setIsSupplier] = useState<any>(false);
    const [paymentMethod, setPaymentMethod] = useState<any>([]);
    const [fundaccount, setFundaccount] = useState<any>([]);
    const [type_payment_method_id, setType_payment_method_id] = useState<any>();
    const [dataCheck, setDataCheck] = useState<any>();
    const { closeModal, action, onlyView } = props
    const type = action?.type

    useEffect(() => {
        loadInit();
        setActionType(action?.type);
        setView(onlyView);
    }, []);
    useEffect(() => {
        loadDataFundaccount();
    },[type_payment_method_id, data?.branch_id])
    useEffect(() => {
        if(action?.data?.id){
            loadData(action?.data?.id)
        }
    }, [action?.data]);

    useEffect(() => {
        if(props?.customer_id){
            setIsCustomer(true)
            loadDataCustomer(props?.customer_id)
        }
    }, [props?.customer_id]);

    useEffect(() => {
        if(props?.supplier_id){
            setIsSupplier(true)
            loadDataSupplier(props?.supplier_id)
        }
    }, [props?.supplier_id]);

    useEffect(() => {
        if(props?.designation_id){
            setIsSource(true)
            loadSearchDesignatioCodeDetail(props?.designation_id)
        }
    }, [props?.designation_id]);

    useEffect(() => {
        loadReceiptsType()
    }, [data?.receipts_group]);

    useEffect(() => {
        if(props?.designation_ids){
            setIsSource(true)
            loadAllDesignationDetailSync(props?.designation_ids)
        }
    }, [props?.designation_ids]);

    useEffect(() => {
        if(props?.import_id){
            setIsSource(true)
            loadSearchImportCodeDetail(props?.import_id)
        }
    }, [props?.import_id]);


    useEffect(() => {
        if(props?.customer_id){
            setIsCustomer(true)
            setData({
                ...data,
                receipts_group: 'customer',
                payment_uid: props?.user?.id,
                customer_receiver_uid: Number(props?.customer_id),
                branch_id: props?.user?.branch_id?.id,
            })
            
        }
    }, [props?.customer_id]);

    const loadInit = async () => {
        const params = {
            status:1,
            page:1,
            limit: 300,
        }
        const [
            responseType,
            responseUser,
            responseBranch,
            responseCustomer,
            responseSupplier,
            responsePaymentMethod
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/receiptstype`, {
                ...params,
                type: 'payment'
            }),
            APIClient.GET(`${baseUrl}/user`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/branch`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/customer`, {
                ...params,
                limit: 3000,
            }),
            APIClient.GET(`${baseUrl}/supplier`, {
                ...params,
            }),
            APIClient.GET(`${baseUrl}/payment-method`, {
                ...params,
            }),
        ]);
        if (responsePaymentMethod.response?.data !== undefined) {
            let ListArr:any = [];
            responsePaymentMethod.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setPaymentMethod(ListArr)
        }
        if (responseType.response?.data !== undefined) {
            let ListArr:any = [];
            responseType.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setReceipts_type(ListArr)
        }
        if (responseUser.response?.data !== undefined) {
            let ListArr:any = [];
            responseUser.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setUser(ListArr)
        }
        if (responseBranch.response?.data !== undefined) {
            let ListArr:any = [];
            responseBranch.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setbranch(ListArr)
        }
        if (responseCustomer.response?.data !== undefined) {
            let ListArr:any = [];
            responseCustomer.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setCustomers(ListArr)
        }
        if (responseSupplier.response?.data !== undefined) {
            let ListArr:any = [];
            responseSupplier.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setSupplier(ListArr)
        }
    }

    const loadReceiptsType = async () => {
        const params = {
            status:1,
            page:1,
            limit: 100,
        }
        const [
            responseType,
        ] = await Promise.all([
            APIClient.GET(`${baseUrl}/receiptstype`, {
                ...params,
                type: 'payment',
                classify: data?.receipts_group
            }),
        ]);
        if (responseType.response?.data !== undefined) {
            let ListArr:any = [];
            responseType.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.id,
                    label: e?.name
                })
            })
            setReceipts_type(ListArr)
        }
    }

    const loadData = async (id:number) => {
        const url = `${baseUrl}/payment/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const data = {
                ...resData,
                payment_method_id: resData?.payment_method_id?.id,
                customer_receiver_uid: resData?.customer_receiver_uid?.id,
                user_receiver_uid: resData?.user_receiver_uid?.id,
                supplier_receiver_uid: resData?.supplier_receiver_uid?.id,
                receipts_type_id: resData?.receipts_type_id?.id,
                payment_uid: resData?.payment_uid?.id,
                branch_id: props?.user?.branch_id?.id,
                fundaccount_id: resData?.fundaccount_id?.id,
                source_code: resData?.source_code && JSON.parse(resData?.source_code)

            }
            setDataCheck(data)
            setData(data)
            setDataCurrent(data)
        }
    }

     // tài khoản quỹ
  const loadDataFundaccount = async () => {
    const params = {
      status: 1,
      page: 1,
      limit: 100,
      type: type_payment_method_id?.fundaccount_type
    };
    const url = `${baseUrl}/fundaccount`;
    setLoading(true);
    let response = await APIClient.GET(url,params)
    setLoading(false);
    if(response.error !== undefined) {
      toast.error(response.error.error_description)
    } else if (response.response !== undefined) {
      const resData = response.response;
      let ListArr: any = [];
      resData?.data?.map((e: any) => {
        if(e?.status == 1 && e?.branch_id?.id == data?.branch_id) {
            ListArr?.push({
          ...e,
          value: e?.id,
          label: e?.name,
        });
        }
        
      });
      setFundaccount(ListArr)
    }
  }

    //thông tin khash hàng
    const loadDataCustomer = async (id:number) => {
        const url = `${baseUrl}/customer/${id}`;
        setLoading(true)
        const [response, responseCode]:any = await Promise.all([
            await APIClient.GET(url),
            await APIClient.GET(`${baseUrl}/search/source-code-none-paid/customer`,{customer_id: id}),
        ]);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            if(resData?.total_debt > 0){
                toast.error("Hiện tại nhà cung cấp ko có công nợ để tạo phiếu chi")
                closeModal()
            }
            if (responseCode.response !== undefined) {
                const code = responseCode.response?.data?.reduce((prev:any, item:any)=>{
                    prev = [...prev, item?.code]
                    return prev
                },[])
                data.source_code = code
            }
            setDataCustomer(resData)
            setData({
                ...data,
                payment_total:-resData?.total_debt,
                max_payment_total:-resData?.total_debt,
                receipts_group: 'customer',
                payment_uid: props?.user?.id,
                customer_receiver_uid: Number(props?.customer_id),
                branch_id: props?.user?.branch_id?.id,
            })
            
        }
    }
    //thông tin nhà cung cấp
    const loadDataSupplier = async (id:number) => {
        const url = `${baseUrl}/supplier/${id}`;
        setLoading(true)
        const [response, responseCode]:any = await Promise.all([
            await APIClient.GET(url),
            await APIClient.GET(`${baseUrl}/search/source-code-none-paid/supplier`,{supplier_id: id}),
        ]);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            if(resData?.total_debt < 0){
                toast.error("Hiện tại nhà cung cấp ko có công nợ để tạo phiếu chi")
                closeModal()
            }
            if (responseCode.response !== undefined) {
                const code = responseCode.response?.data?.reduce((prev:any, item:any)=>{
                    prev = [...prev, item?.code]
                    return prev
                },[])
                data.source_code = code
            }
            setDataSupplier(resData)
            setData({
                ...data,
                payment_total:resData?.total_debt,
                max_payment_total:resData?.total_debt,
                receipts_group: 'supplier',
                payment_uid: props?.user?.id,
                supplier_receiver_uid: Number(props?.supplier_id),
                branch_id: props?.user?.branch_id?.id,
            })
        }
    }

    const loadAllDesignationDetailSync =  async (designation_ids:any) => {
        setLoading(true)
        const dataAll:any = await loadAllDesignationDetail(designation_ids)
        const checkCusstomer = dataAll?.reduce((prev:any, item:any)=>{
            if(dataAll[0]?.customer_id?.id !== item?.customer_id?.id){
                prev = false
            }
            return prev
        }, true)
        const {total, codes}:any = dataAll?.reduce((prev:any, item:any)=>{
            const totalPayment = item?.designation_payments?.reduce(
                (prevPayment: any, itemPayment: any) => {
                  if (itemPayment?.payment_total) prevPayment = prevPayment + Number(itemPayment?.payment_total);
                  return prevPayment;
                },
                0
            );
            const totalService = item?.designation_services?.reduce(
                (prevService: any, itemService: any) => {
                  prevService = prevService + ((Number(itemService?.service_price || 0) * Number(itemService?.service_quantity || 0)) - Number(itemService?.service_discount || 0));
                  return prevService;
                },
                0
            );
            const payment_total = totalService - totalPayment;
            if(payment_total > 0){
                prev = {
                    total: prev?.total + payment_total,
                    codes: [...prev?.codes, item?.code]
                }
            }
            return prev
        }, {
            total: 0, codes: []
        })
        setLoading(false)
        
        if(!checkCusstomer){
            toast.error("Chỉ có thể thu tiền cho nhiều phiếu của 1 khách hàng")
            closeModal()
            return
        }
        if(codes?.length === 0){
            toast.error("Các dịch vụ trên đã được thanh toán")
            closeModal()
            return
        }
        if(codes?.length !== dataAll?.length){
            toast.warning("Đã loại bỏ một số dịch vụ đã thanh toán ra khỏi phiếu chi tiền")
        }
        
        setData({
            ...data,
            receipts_group: 'customer',
            payment_uid: props?.user?.id,
            customer_receiver_uid: dataAll[0]?.customer_id?.id,
            // branch_id: resData?.branch_id?.id,
            branch_id: props?.user?.branch_id?.id,
            max_payment_total: total,
            source_code: codes,
            payment_total: total,
        })
    }

    const loadSearchImportCodeDetail = async (id:number) => {
        const url = `${baseUrl}/stock/import/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const totalPayment = resData?.stock_import_payments?.reduce((prev:any, item:any)=>{
                if(item?.payment_total) prev = prev + Number(item?.payment_total)
                return prev
            },0)
            const payment_total = resData?.sub_total - totalPayment
            setData({
                ...data,
                receipts_group: 'supplier',
                payment_uid: props?.user?.id,
                supplier_receiver_uid: resData?.supplier_id?.id,
                source_code: [resData?.code],
                branch_id: resData?.branch_id?.id,
                payment_total,
                max_payment_total: payment_total
            })
            
        }
        return
    }

    const loadSearchDesignatioCodeDetail = async (id:number) => {
        const url = `${baseUrl}/designation/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            const totalPayment = resData?.designation_payments?.reduce((prev:any, item:any)=>{
                if(item?.payment_total) prev = prev + Number(item?.payment_total)
                return prev
            },0)
            const totalService = resData?.designation_services?.reduce(
                (prev: any, item: any) => {
                  prev = prev + ((Number(item?.service_price || 0) * Number(item?.service_quantity || 0)) - Number(item?.service_discount || 0));
                  return prev;
                },
                0
              );
            const payment_total = totalService - totalPayment
            setData({
                ...data,
                receipts_group: 'customer',
                payment_uid: props?.user?.id,
                customer_receiver_uid: resData?.customer_id?.id,
                source_code: [resData?.code],
                branch_id: resData?.branch_id?.id,
                payment_total,
                max_payment_total: payment_total
            })
            
        }
        return
    }

    const loadAllDesignationDetail = async (designation_ids:any) => {
        const url = `${baseUrl}/designation`;
        const designation: any = await APIClient.GET(url,{
            ids: designation_ids
        });
        return designation?.response?.data || []
    }

    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target
        if (value === " ") return;
        if (name === "phone") {
            value = value.replace(/[a-zA-Z!@#$%^&*();.',/\|{}ơ]/g, "")
        }
        console.log(name, data?.max_payment_total)
        if (name === "payment_total" && data?.max_payment_total) {
            value = data?.max_payment_total
            toast.warning('Vượt quá số tiền cần phải thanh toán')
        }
        setData({
            ...data,
            [name]: value
        })
    }

    const [loadingDesignation, setLoadingSearchCode] = useState(false);

    const [queryDesignation, setQuerySearchCode] = useState('')

    const loadSearchCode = async () => {
        setLoadingSearchCode(true)
        let response: any = await APIClient.GET(`${baseUrl}/search/source-code`,{
            page: 1,
            limit: 100,
            name: queryDesignation
        });
        setLoadingSearchCode(false)
        if (response.response?.data !== undefined) {
            let ListArr:any = [];
            response.response?.data?.map((e:any) => {
                ListArr?.push({
                    ...e,
                    value: e?.code,
                    label: e?.code
                })
            })
            return ListArr
        }else{
            return []
        }
    };

    const handleInputChangeSearchCode = (newValue:any) => {
        setQuerySearchCode( newValue);
        return newValue;
    };

    const validationFrom = () => {
        // if (!(data?.receipts_type_id)) {
        //     toast.warning('Loại phiếu chi không được để trống!');
        //     return false
        // }
        if (!(data?.receipts_group)) {
            toast.warning('Nhóm phiếu chi không được để trống!');
            return false
        }
        if (data?.receipts_group === 'customer' && !(data?.customer_receiver_uid)) {
            toast.warning('Người nhận không được để trống!');
            return false
        }else if(data?.receipts_group === 'user' && !(data?.user_receiver_uid)){
            toast.warning('Người nhận không được để trống!');
            return false
        }else if(data?.receipts_group === 'supplier' && !(data?.supplier_receiver_uid)){
            toast.warning('Người nhận không được để trống!');
            return false
        }else if(data?.receipts_group === 'other' && !(data?.user_receiver_uid)){
            toast.warning('Người nhận không được để trống!');
            return false
        }
        if((data?.receipts_group === 'supplier' || data?.receipts_group === 'customer' || data?.receipts_group === 'user') && (source_code?.length === 0 || source_code == undefined)){
            toast.warning('Mã chứng từ gốc không được để trống!');
            return false
        }
        if (!(data?.day)) {
            toast.warning('Ngày chi không được để trống!');
            return false
        }
        if(!(data?.payment_uid)){
            toast.warning('Người thu không được để trống!');
            return false
        }
        if (!(data?.payment_total)) {
            toast.warning('Số tiền không được để trống!');
            return false
        }
        if (!(data?.payment_method_id)) {
            toast.warning('Hình thức không được để trống!');
            return false
        }
        if (!(data?.branch_id)) {
            toast.warning('Cơ sở không được để trống!');
            return false
        }
        if (!(data?.fundaccount_id)) {
            toast.warning('Tài khoản quỹ không được để trống!');
            return false
        }
        
        return true
    }
    
    const handleSubmit = async() => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/payment`;
        const params = {
            "code": data?.code,
            "receipts_type_id": data?.receipts_type_id,
            "receipts_group": data?.receipts_group,
            "user_receiver_uid": data?.user_receiver_uid,
            "customer_receiver_uid": data?.customer_receiver_uid,
            "supplier_receiver_uid": data?.supplier_receiver_uid,
            "day": moment(data?.day).valueOf(),
            "payment_uid": data?.payment_uid,
            "source_code": data?.source_code,
            "payment_total": Number(data?.payment_total),
            "payment_method_id": data?.payment_method_id,
            "branch_id": data?.branch_id,
            "note": data?.note,
            "fundaccount_id": data?.fundaccount_id,
            // "status": props?.designation_id ? 1: 0,
            "status": 1
        }
        let response: any = await APIClient.POST(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Tạo phiếu chi thành công')
            closeModal()
            props.loadData()
        }
    }

    const handleEdit = async () => {
        if (!validationFrom()) return;
        setLoading(true);
        const url = `${baseUrl}/payment/${data?.id}`;
        const params = {
          fundaccount_id: data?.fundaccount_id,
          source_code: dataCurrent?.source_code?.length == 0 ? data?.source_code : undefined,
          note: data?.note
        }
        let response: any = await APIClient.POST(url, params);
        
        setLoading(false);
        if (response.error !== undefined) {
          toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
          console.log("respone", response.response);
          toast.success("Chỉnh sửa phiếu chi thành công");
          closeModal();
        }
      }

    if(!checkRole(props?.user?.roles, ['paymentEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }
    
    const source_code = data?.source_code?.reduce((prev:any, item:any)=>{
        var id = item.replace(/\D/g, "");
        prev = [...prev,{
            name: item,
            id: Number(id)
        }]
        return prev
    },[])
    console.log('dataPer', source_code)
    return (
        <CardBody className='p-0' style={{width: 860}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    actionType === 'add' ? "Tạo phiếu chi" :
                    actionType === 'addPayment' ? "Tạo phiếu chi" :
                    actionType === 'view' ? "Chi tiết phiếu chi" : 
                    actionType === 'edit' ? "Chỉnh sửa phiếu chi" 
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body p-4">
                <PageContent className={view ? 'only-view' : ''}>
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <Row>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Mã phiếu</Label>
                                        <Input type="text" value={data?.code} onChange={(e: any) => handleChangeInput(e)} name="code" placeholder="Nhập mã phiếu" />
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Nhóm phiếu chi</Label>
                                        <Select
                                            placeholder={view === 'view' && !data?.receipts_group ? '---': "Chọn nhóm phiếu chi" }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={view || isSource || isCustomer || isSupplier || actionType === "edit"}
                                            onChange={(val: any) => {
                                                setData({ 
                                                    ...data, 
                                                    receipts_group: val?.value, 
                                                    customer_receiver_uid: null,
                                                    user_receiver_uid: null,
                                                    supplier_receiver_uid: null,
                                                })
                                            }}
                                            value={ReceiptsGroup?.filter(
                                                (option: any) => data?.receipts_group == option.value
                                            )}
                                            options={ReceiptsGroup}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Loại phiếu chi</Label>
                                        <Select
                                            placeholder={actionType === 'view' && !data?.receipts_type_id ? '---': "Chọn loại phiếu chi" }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView || !data?.receipts_group || actionType === "edit"}
                                            onChange={(val: any) => {
                                                setData({ ...data, receipts_type_id: val?.value })
                                            }}
                                            value={payment_type?.filter(
                                                (option: any) => data?.receipts_type_id == option.value
                                            )}
                                            options={payment_type}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Người chi</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.payment_uid ? '---': "Chọn chi" }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView || isSource || actionType === "edit"}
                                            onChange={(val: any) => {
                                                setData({ ...data, payment_uid: val?.value })
                                            }}
                                            value={users?.filter(
                                                (option: any) => data?.payment_uid == option.value
                                            )}
                                            options={users}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Ngày chi</Label>
                                        <InputGroup>
                                        {(actionType !== undefined && actionType == "add") ? (
                                            <Flatpickr
                                            value={[new Date(data?.day)]}
                                            onChange={(date: any) => {
                                                setData({
                                                    ...data,
                                                    day: date[0] ? moment(date[0]) : undefined
                                                })
                                            }}
                                            options={{
                                                locale: Vietnamese,
                                                allowInput:true,
                                                dateFormat: "d/m/Y",
                                                altInputClass : "date-range",
                                                minDate:'today'
                                            }}
                                            placeholder="dd/mm/yy"
                                            disabled = {actionType === "edit"}
                                        />
                                        ) : (
                                            <Flatpickr
                                                value={[new Date(data?.day)]}
                                                onChange={(date: any) => {
                                                    setData({
                                                        ...data,
                                                        day: date[0] ? moment(date[0]) : undefined
                                                    })
                                                }}
                                                options={{
                                                    locale: Vietnamese,
                                                    allowInput:true,
                                                    dateFormat: "d/m/Y",
                                                    altInputClass : "date-range",
                                                }}
                                                placeholder="dd/mm/yy"
                                                disabled = {actionType === "edit"}
                                            />
                                        ) }
                                            
                                            {
                                                (actionType != "view" && actionType !== "edit") &&
                                                <InputGroupAddon addonType="append" className='d-flex align-items-center'>
                                                    <img src={IconCalendar} alt="icon" />
                                                </InputGroupAddon>
                                            }
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Người nhận</Label>
                                        {data?.receipts_group === 'customer' ?
                                            <Select
                                                placeholder={type === 'view' && !data?.customer_receiver_uid ? '---': "Chọn người nhận" }
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView || isSource || isCustomer || !data?.receipts_group || actionType === "edit"}
                                                onChange={(val: any) => {
                                                    setData({ ...data, customer_receiver_uid: val?.value })
                                                }}
                                                value={customers?.filter(
                                                    (option: any) => data?.customer_receiver_uid == option.value
                                                )}
                                                options={customers}
                                                styles={customStyles}
                                            ></Select>:
                                        data?.receipts_group === 'supplier' ?
                                            <Select
                                                placeholder={type === 'view' && !data?.supplier_receiver_uid ? '---': "Chọn người nhận" }
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView || isSource || isSupplier || !data?.receipts_group || actionType === "edit"}
                                                onChange={(val: any) => {
                                                    setData({ ...data, supplier_receiver_uid: val?.value })
                                                }}
                                                value={supplier?.filter(
                                                    (option: any) => data?.supplier_receiver_uid == option.value
                                                )}
                                                options={supplier}
                                                styles={customStyles}
                                            ></Select>:
                                            <Select
                                                placeholder={type === 'view' && !data?.user_receiver_uid ? '---': "Chọn người nhận" }
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                isDisabled={onlyView || isSource || !data?.receipts_group || actionType === "edit"}
                                                onChange={(val: any) => {
                                                    setData({ ...data, user_receiver_uid: val?.value })
                                                }}
                                                value={users?.filter(
                                                    (option: any) => data?.user_receiver_uid == option.value
                                                )}
                                                options={users}
                                                styles={customStyles}
                                            ></Select>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>{(data?.receipts_group === 'supplier' || data?.receipts_group === 'customer' || data?.receipts_group === 'user') && <span>*</span>} Mã chứng từ gốc</Label>
                                        {actionType === 'view' || isSource || (actionType === "edit" && dataCurrent?.source_code !== null && dataCurrent?.source_code !== undefined && dataCurrent?.source_code?.length !== 0) ?
                                        <>
                                            {/* <Input type="text" value={data?.source_code?.join(',') || '---'} placeholder="Nhập mã chứng từ" /> */}
                                            <div>{source_code?.map((item:any, index:number)=>{
                                                return <>
                                                    {index !== 0 ? ', ':''}
                                                    <Link key={`source_code-${index}`} to={getLinkBySourceCode(item?.name)}>{item?.name}</Link>
                                                </>
                                            })}</div>
                                        </>
                                            :
                                            <AsyncSelect
                                                className="react-select mb-2"
                                                classNamePrefix="react-select"
                                                onInputChange={handleInputChangeSearchCode}
                                                loadOptions={loadSearchCode}
                                                inputValue={queryDesignation}
                                                placeholder={loadingDesignation ? "Đang tải dữ liệu..." : "Nhập mã chứng từ"}
                                                noOptionsMessage={() => queryDesignation ? "Không tìm thấy dữ liệu" : 'Nhập mã chứng từ'}
                                                loadingMessage={() => 'searching...'}
                                                styles={customStyles}
                                                cacheOptions 
                                                isMulti
                                                onChange={(val: any) => {
                                                    const source_code = val ? val?.reduce((prev:any, item:any)=>{
                                                        prev = [...prev, item?.code]
                                                        return prev
                                                    },[]) : []
                                                    setData({ ...data, source_code: source_code })
                                                }}
                                                value={data?.source_code?.reduce((prev:any, item:any)=>{
                                                    prev = [...prev,{
                                                        value: item,
                                                        label:item,
                                                        code:item,
                                                    }]
                                                    return prev
                                                },[])}
                                                isDisabled={actionType === 'view'}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Số tiền</Label>
                                        <NumberFormat 
                                            onChange={(e: any) => {
                                                let value = TextUtils.onlyNumber(e.target.value)
                                                if (data?.max_payment_total && Number(value) > Number(data?.max_payment_total)) {
                                                    value = data?.max_payment_total
                                                    toast.warning('Vượt quá số tiền cần phải thanh toán')
                                                }
                                                setData({ ...data, payment_total: value })
                                            }}
                                            name={'payment_total'} type={'text'} className="form-control" 
                                            value={type === 'view' && !data?.payment_total ? '---': data?.payment_total}
                                            placeholder={(type=='view' && !data?.payment_total) ? "---" : "Nhập số tiền..."} thousandSeparator={true}
                                            disabled = {actionType === "edit"} 
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Hình thức</Label>
                                        <Select
                                            placeholder={actionType === 'view' && !data?.customer_id ? '---': "Chọn hình thức" }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView || actionType == "edit"}
                                            onChange={(val: any) => {
                                                setType_payment_method_id(val)
                                                setData({ ...data, payment_method_id: val?.value, fundaccount_id: '' })
                                            }}
                                            value={paymentMethod?.filter(
                                                (option: any) => data?.payment_method_id == option.value
                                            )}
                                            options={paymentMethod}
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label><span>*</span> Cơ sở nhận tiền</Label>
                                        <Select
                                            placeholder={type === 'view' && !data?.branch_id ? '---': "Chọn cơ sở" }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={onlyView || isSource || actionType == "edit"}
                                            onChange={(val: any) => {
                                                setData({ ...data, branch_id: val?.value })
                                            }}
                                            value={branch?.filter(
                                                (option: any) => data?.branch_id == option.value
                                            )}
                                            options={branch}
                                            menuPlacement="top"
                                            styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                    {props?.customer_id && 
                                        <FormGroup className='nutri-form'>
                                            <Label>Công nợ hiện tại</Label>
                                            <ValueText><b>{PriceUtils.format(dataCustomer?.total_debt)}</b></ValueText>
                                        </FormGroup>
                                    }
                                    {props?.supplier_id && 
                                        <FormGroup className='nutri-form'>
                                            <Label>Công nợ hiện tại</Label>
                                            <ValueText><b>{PriceUtils.format(dataSupplier?.total_debt)}</b></ValueText>
                                        </FormGroup>
                                    }
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className='nutri-form'>
                                        <Label>Ghi chú</Label>
                                        <Input type="text" value={actionType === 'view' && !data?.note ? '---': data?.note} onChange={(e: any) => handleChangeInput(e)} name="note" placeholder="Nhập ghi chú" />
                                    </FormGroup>
                                </Col>
                                <Col md={4} xs={12}>
                                    <FormGroup className="nutri-form">
                                    <Label><span>*</span> Tài khoản quỹ</Label>
                                        <Select
                                            placeholder={
                                                actionType === "view" && !data?.fundaccount_id
                                                ? "---"
                                                : "Chọn tài khoản quỹ"
                                            }
                                            className="react-select mb-2"
                                            classNamePrefix="react-select"
                                            isDisabled={view || (actionType == 'edit' && dataCheck?.fundaccount_id)}
                                            onChange={(val: any) => {
                                                setData({ ...data, fundaccount_id: val?.value });
                                            }}
                                            value={fundaccount?.filter(
                                                (option: any) =>
                                                data?.fundaccount_id == option.value
                                            )}
                                            options={fundaccount}
                                            maxMenuHeight={100}
                                            // styles={customStyles}
                                        ></Select>
                                    </FormGroup>
                                    </Col>
                                {
                                    actionType == 'view' &&
                                    <>
                                        <Col md={4} xs={12}>
                                            <FormGroup className='nutri-form'>
                                                <Label>Trạng thái</Label>
                                                <ValueText className={data?.status == 1 ? 'text-success' : "text-dark"}>{data?.status == 1 ? 'Đã thu' : "Mới"}</ValueText>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <FormGroup className='nutri-form'>
                                                <Label>Người tạo</Label>
                                                <ValueText>{data?.created_uid?.name}</ValueText>
                                            </FormGroup>
                                        </Col>
                                        <Col md={4} xs={12}>
                                            <FormGroup className='nutri-form'>
                                                <Label>Thời gian tạo</Label>
                                                <ValueText>{moment(data?.created_time).format('HH:mm:ss DD/MM/YYYY')}</ValueText>
                                            </FormGroup>
                                        </Col>
                                    </>
                                }
                            </Row>
                        </FormGroup>
                    </Col>
                </PageContent>
            </div>
            {actionType !== 'view' &&
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        actionType === 'add' && handleSubmit() 
                        actionType === 'addPayment' && handleSubmit() 
                        actionType === "edit" && handleEdit();
                    }}
                    className="ml-2" color="success" type="button"
                >{(actionType === 'add' || actionType === "addPayment" || actionType === "edit") ? "Lưu": "Xác nhận"}</Button>
                {actionType === "edit" && (
                    <Button
                        onClick = {() => {
                            closeModal()
                        }}
                        className="success-bland ml-2"
                        color="success"
                        type="button"
                    >
                        Huỷ
                    </Button>
                )}
            </div>}
            {actionType == "view" && (
                <div className="modal-footer">
                    <Button
                        onClick={() => {
                            setActionType("edit")
                            setView(undefined)
                        }}
                        className="ml-2"
                        color="success"
                        type="button"
                    >
                        Chỉnh sửa
                    </Button>
              </div>
            )}
            {loading && <Loader />}
        </CardBody>

    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`

const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
      }),
  };

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(Detail)